import React from 'react';
import InfoTooltip from './InfoTooltip';
import { ORANGE_BOOK_DATA_FILES_URL } from '../utils/obTypeLabels';

export interface ObTypeHeaderTooltipProps {
  /** Forwarded to InfoTooltip — override for a call site nested above InfoTooltip's own default. */
  zIndex?: number;
}

/**
 * Field-level tooltip for the "Listing Status" label — explains what the
 * field means and links back to the source. Mirrors
 * ApplTypeHeaderTooltip.tsx's pattern (human direction, 2026-09-28 — a bare
 * "RX"/"OTC"/"DISCN" carries no explanation anywhere `type` is shown
 * standalone).
 */
const ObTypeHeaderTooltip: React.FC<ObTypeHeaderTooltipProps> = ({
  zIndex,
}) => (
  <InfoTooltip
    ariaLabel="About Listing Status"
    zIndex={zIndex}
    interactive
    text={
      <span>
        RX = Prescription, OTC = Over-the-Counter, DISCN = Discontinued
        <br />
        Source:{' '}
        <a
          href={ORANGE_BOOK_DATA_FILES_URL}
          target="_blank"
          rel="noopener"
          style={{ color: 'inherit', textDecoration: 'underline' }}>
          Orange Book Data Files
        </a>
      </span>
    }
  />
);

export default ObTypeHeaderTooltip;
